import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BranchMatserService {

  public baseUrl: string;
  public newbaseUrl: string;
  selecteBranchMasterData: any = {};
  selecteServiceData:any = []
  constructor(public http: HttpClient, public authservice: AuthService) {
    this.baseUrl = this.authservice.baseUrl;
    this.newbaseUrl = this.authservice.newbaseUrl;
  }
  saveDepartmentdata(payload){
    return this.http.post<any>(this.newbaseUrl + "SurgeryMaster/InsertSurgeryDepartmentMaster", payload)
  }
  saveSurgeryCategorydata(payload){
    return this.http.post<any>(this.newbaseUrl + "SurgeryMaster/InsertSurgeryCategoryMaster", payload)
  }
  getServicemaster(id: any,moudletypeid:any) {
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetServiceMaster/" + id +'/'+moudletypeid)
  }
  getServicedisplaymaster(id: any) {
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetServiceNameRelationMasterByServiceId/" + id)
  }
  getRatelistDisplay(id){
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetServiceNameRelationRateListDetailByDisplayNameId/" + id)
  }
  getRatelistbyServiceid(moudletypeid:any){
    return this.http.get<any>(this.newbaseUrl + "RateList/GetRateListByName/0/"+moudletypeid);
  }
  getCategorybyServiceList(moudletypeid:any){
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetServiceCategoryMaster/0/"+moudletypeid);
  }
  
  getBrachMasterList() {
    return this.http.get<any>(this.newbaseUrl + "branchMaster/getBranchAll")
  }
getroom(){
  return this.http.get<any>(this.newbaseUrl + "Common/GetHospitalRoomByBranchId/"+this.authservice.Loggeduser.branchid)

}

GetRoles(){
  return this.http.get<any>(this.newbaseUrl + "UserMaster/GetRoles")
}
  getBrachMasterItem(id: any) {
    return this.http.get<any>(this.newbaseUrl + "branchMaster/GetBranch/" + id)
  }

  getState() {
    return this.http.get<any>(this.newbaseUrl + "LocationMaster/GetState/0")
  }

  addBranchMaster(data: any) {
    return this.http.post<any>(this.newbaseUrl + "BranchMaster/InsertBranchMaster", data)
  }
  getAuthusermaster(id){
    return this.http.get<any>(this.newbaseUrl +"UserMaster/GetUserAuthType/"+ id);
  }
  addauthMaster(payload){
     return this.http.post<any>(this.newbaseUrl + "UserMaster/InsertUserAuthTypeMaster", payload)
  }
  GetUserAuthTypeMenuPermissionDetail(id){
    return this.http.get<any>(this.newbaseUrl +"UserMaster/GetUserAuthTypeMenuPermissionDetail/"+ id);
  }
  InsertUserAuthTypeMenuPermissionDetail(payload){
    return this.http.post<any>(this.newbaseUrl + "UserMaster/InsertUserAuthTypeMenuPermissionDetail", payload)
  }

  insertAuthmaster(rowdata){
    return this.http.post<any>(this.newbaseUrl + "UserMaster/InsertUserAuthTypeMaster", rowdata)
  }
  InsertRoomCategoryMaster(rowdata){
    return this.http.post<any>(this.newbaseUrl + "IPD/InsertRoomCategoryMaster", rowdata)
  }
  getOperationTheatreMaster() {
    return this.http.get<any>(this.newbaseUrl + "MedicalRecordMaster/GetOperationTheatreMaster/0")
  } 
  InsertOperationTheatreMaster(rowdata){
    return this.http.post<any>(this.newbaseUrl + "MedicalRecordMaster/InsertOperationTheatreMaster", rowdata)
  }
  saveDIsplayServiceName(payload){
    return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertServiceNameRelationMaster", payload)
  }
  InsertServiceNameRelationRateList(payload){
    return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertServiceNameRelationRateListDetail", payload)
  }
   getServiceDepartmentMaster(modultypeid:any){
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetServiceDepartmentMaster/0/"+modultypeid)
   }
   InsertServiceDeparment(payload){
    return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertServiceDepartmentMaster", payload)
  }
  InsertServiceCategory(payload){
    return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertServiceCategoryMaster", payload)
  }
  GetRateListDetailByServiceId(serviceid){
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetRateListDetailByServiceId/"+ serviceid);
  }
  GetLabFormatMasterByServiceId(serviceid){
    return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetLabFormatMasterByServiceId/"+ serviceid);
  }
  GetNameByType(parameter){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/"+ parameter);
  }

  GetLabHeadGroupMaster(){
  return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetLabHeadGroupMaster/"+ 0);
  }

  GetLabHeadAgeGroupDetailByHeadIDByAgeGroupIdByTranId(headId){
  return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetLabHeadAgeGroupDetailByHeadIDByAgeGroupIdByTranId/"+headId +'/'+0 + '/' +0);
  }
  InsertServiceMaster(payload){
    return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertServiceMaster", payload)
  }

   InsertLabHeadMaster(payload){
      return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertLabHeadMaster", payload)
   }
   
  GetAccountMaster(parameter:any){
    return this.http.get<any>(this.newbaseUrl + "AccountMaster/GetAccountMaster/"+ parameter);
  }

  GetLabHeadMasterByHeadId(parameter){
   return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetLabHeadMasterByHeadId/"+ parameter);
  }

  GetLabHeadMasterByHeadIdByHeadGroupIdByFlagTypeId(parameter){
       return this.http.get<any>(this.newbaseUrl + "ServiceMaster/GetLabHeadMasterByHeadIdByHeadGroupIdByFlagTypeId/"+ 0 +'/'+ parameter + '/' +0);
  }
  GetAccountHeadMaster(parameter){
    return this.http.get<any>(this.newbaseUrl + "AccountMaster/GetAccountHeadMaster/"+ parameter);
  }
  GetAccountTypeMaster(parameter){
    return this.http.get<any>(this.newbaseUrl + "AccountMaster/GetAccountTypeMaster/"+ parameter);
  }
  InsertAccountMaster(payload){
    return this.http.post<any>(this.newbaseUrl + "AccountMaster/InsertAccountMaster", payload)
  }
  InsertAccountHeadMaster(payload){
    return this.http.post<any>(this.newbaseUrl + "AccountMaster/InsertAccountHeadMaster", payload)
  }
  InsertLabHeadGroupMaster(payload){
  return this.http.post<any>(this.newbaseUrl + "ServiceMaster/InsertLabHeadGroupMaster", payload)
  }

  InsertAccountTypeMaster(payload){
    return this.http.post<any>(this.newbaseUrl + "AccountMaster/InsertAccountTypeMaster", payload)
  }
  getNamebyType(type){
    return this.http.get<any>(this.newbaseUrl +"Common/GetNameByType/"+type);
  } 
  InsertDocumentMaster(payload){
    return this.http.post<any>(this.newbaseUrl + "common/InsertDocumentMaster", payload)
  }
  
  GetDocumentMaster(type1,type2){
    return this.http.get<any>(this.newbaseUrl +"common/GetDocumentMaster/"+type1 +'/'+type2);
  } 

  getmenumasterPermission(userid){
    return this.http.get<any>(this.newbaseUrl +"UserMaster/GetWebMenuUserPermissionDetailByUserId/"+userid);
  } 
  
  InsertWebMenuUserPermission(payload){
    return this.http.post<any>(this.newbaseUrl + "UserMaster/InsertWebMenuUserPermissionDetail", payload)
  }
  insertopdtestname(payload){
    return this.http.post<any>(this.newbaseUrl + "Masters/InsertOptoTest", payload)
  }
  

    // CheckList Master post Api...
    InsertPreOperativeCheckListMaster(payload:any){
      return this.http.post(this.newbaseUrl + "IPDWorkupMaster/InsertPreOperativeCheckListMaster",payload);
    }
  
    InsertPostOperativeCheckListMaster(payload:any){
     return this.http.post(this.newbaseUrl + "IPDWorkupMaster/InsertPostOperativeCheckListMaster",payload);
    }
  
    InsertGaCheckListMaster(payload:any){
     return this.http.post(this.newbaseUrl + "IPDWorkupMaster/InsertGaCheckListMaster",payload);
    }
  
    InsertSSCheckListMaster(payload:any){
      return this.http.post(this.newbaseUrl + "IPDWorkupMaster/InsertSSCheckListMaster",payload);
    }
  
     // CheckList Master get Api...
    GetPreOperativeCheckListMaster(){
      return this.http.get(this.newbaseUrl + "IPDWorkupMaster/GetPreOperativeCheckListMaster");
    }
  
    GetPostOperativeCheckListMaster(){
      return this.http.get(this.newbaseUrl + "IPDWorkupMaster/GetPostOperativeCheckListMaster");
    }
  
    Getgachecklistmaster(){
      return this.http.get(this.newbaseUrl + "IPDWorkupMaster/Getgachecklistmaster");
    }
  
    GetSSCheckListMaster(){
      return this.http.get(this.newbaseUrl + "IPDWorkupMaster/GetSSCheckListMaster")
    }


    getServiceList(id:number){
      return this.http.get<any>(this.newbaseUrl + "PackageMaster/GetPackageDetailByPackageId/"+ id)
    }

    getSearchPackageMaster(id:number,search:any){
      return this.http.get<any>(this.newbaseUrl + "PackageMaster/GetPackageMaster/"+ id +"/"+ search)
    }
    
    getPackagePartyRelation(id){
      return this.http.get<any>(this.newbaseUrl + "PackageMaster/GetPackagePartyRelationByPackageId/"+ id)
      
    }

    insertPackageMaster(payload){
      return this.http.post(this.newbaseUrl + "PackageMaster/InsertPackageMaster",payload);
    }

  //  billing Category Master Api
  getBillingCategoryMaster(id){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetBillingCategoryMaster/"+ id)
  }
 
  insertBillingCategoryMasters(payload){
    return this.http.post(this.newbaseUrl + "Masters/InsertBillingCategoryMasters",payload);
  }
  InsertuserMaster(payload){
    return this.http.post(this.newbaseUrl + "UserMaster/InsertuserMaster",payload);
  }

  GetUserDetailsByUserId(id){
    return this.http.get<any>(this.newbaseUrl + "UserMaster/GetUserDetailsByUserId/"+ id)
  }

  GetNameByTypeByBranchId(deptment:any,branchid:any){
    return this.http.get<any>(this.newbaseUrl + "Masters/GetBillingCategoryMaster/"+ deptment +'/'+branchid)
  }

  DEPTMASTER(id){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByTypeByBranchId/DEPTMASTER/"+ id)
  }
  CLINICALDEPARTMENT(id){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByTypeByBranchId/CLINICALDEPARTMENT/"+ id)
  }
  ModuleSpecialityType(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetModuleSpeciality/ModuleSpecialityType")
  }
  ITEMTYPE(){
    return this.http.get<any>(this.newbaseUrl + "Common/GetNameByType/ITEMTYPE")
  }

  GetUserAll(){
    return this.http.get<any>(this.newbaseUrl + "UserMaster/GetAllUsers")
  }


  personMaster(){
   return this.http.get<any>(this.newbaseUrl + "PersonMaster/" + 'REGISTRATION' + '/' + 0)
  }
  // https://localhost:44340/api/UserMaster/GetUserDetailsByUserId/402
  
   getSpeciltiyDatas(firstpage) {
    return this.http.get(this.newbaseUrl + "Common/GetSubSpeciality/" + 0 + '/' + firstpage );
  }
}
